module.exports = __webpack_public_path__ + "static/media/close.c0a237bb.svg";